site.magnific = {
	init: function () {
		$('.box.video a[href*="vimeo.com"],' +
		  '.box.video a[href*="youtube.com"]').magnificPopup({
			type: 'iframe'
		});
	}
};

site.inits.push('site.magnific.init()');
